import React from "react";
import { Container } from "react-bootstrap";
import { BOOKINGS, PRICING_FOOTNOTE, SERVICES } from "../data/shop";
import { Zia } from "./Zia";
import "./Pricing.css";

export const Pricing = () => (
  <section id="pricing" className="pricing">
    <img
      className="pricing__watermark"
      src="/assets/randys-r-emblem.jpg"
      alt=""
      aria-hidden="true"
    />
    <Container>
      <div className="section-head">
        <span className="eyebrow">Our Services</span>
        <h2 className="section-title gold-text">The Price Board</h2>
        <div className="rule">
          <span className="diamond" />
        </div>
      </div>

      <div className="price-board frame bulbs">
        <div className="price-board__inner">
          <ul className="price-board__barbers">
            {BOOKINGS.map((booking) => (
              <li key={booking.barber}>
                <span className="price-board__barber">{booking.barber}</span>
                <span className="price-board__promise">{booking.promise}</span>
              </li>
            ))}
          </ul>

          <ul className="price-board__list">
            {SERVICES.map((service) => (
              <li
                className={`price-row${service.feature ? " is-feature" : ""}`}
                key={service.name}
              >
                <span className="price-row__name">
                  {service.name}
                  <small>{service.note}</small>
                </span>
                <span className="price-row__leader" aria-hidden="true" />
                <span className="price-row__price gold-text">
                  <sup>$</sup>
                  {service.price}
                </span>
              </li>
            ))}
          </ul>

          <p className="price-board__note">
            <Zia size={12} />
            {PRICING_FOOTNOTE}
          </p>
        </div>
      </div>

      <div className="pricing__cta">
        <p className="script">Walk-ins welcome. Appointments encouraged.</p>
        <div className="pricing__cta-actions">
          {BOOKINGS.map((booking, index) => (
            <a
              key={booking.url}
              className={index === 0 ? "btn-shop" : "btn-ghost"}
              href={booking.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Book with {booking.barber}
            </a>
          ))}
        </div>
      </div>
    </Container>
  </section>
);
